import { useMutation, useQueryClient } from "@tanstack/react-query"
import { sendQuotationAdminToBuyer, type CreateQuotationAdminToBuyerPayload } from "@/lib/api/quotation.api"
import { useAuthStore } from "@/store/auth.store"

export function useSendQuotationToBuyer() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CreateQuotationAdminToBuyerPayload) => {
      if (!accessToken) throw new Error("Not authenticated")
      return sendQuotationAdminToBuyer(payload, accessToken)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-seller-quotations"] })
      queryClient.invalidateQueries({ queryKey: ["admin-buyer-quotations"] })
    },
    onError: (error: Error) => {
      console.error("Sending quotation to buyer failed:", error.message)
    },
  })
}
